import { AbstractApiModel } from './abstract-api-model';

export class ExplorerModel extends AbstractApiModel<ExplorerModel> {
  content_url: string;
  top_hat?: string;
  top_front?: string;
  tilt?: string;
  depthcams: string[];
  stereo?: string[];
  fisheyes?: string[];
  inspect_cams?: string[];
  insight_cams?: string[];
  truck: string;
  payload?: string;
  id: number;
  display_name: string;

  deserialize(json: any) {
    this.content_url = json.model_url;
    this.top_hat = json.top_hat;
    this.top_front = json.top_front;
    this.tilt = json.tilt;
    this.depthcams = json.depthcams;
    this.stereo = json.stereo_depthcams;
    this.fisheyes = json.fisheyes;
    this.inspect_cams = json.inspect_cams;
    this.insight_cams = json.insight_cams;
    this.truck = json.truck;
    this.payload = json.payload;
    this.id = json.id;
    this.display_name = json.display_name;

    return super.deserialize(json);
  }

  serialize(): any {
    return Object.assign(super.serialize(), {
        model_url: this.content_url,
        top_hat: this.top_hat,
        top_front: this.top_front,
        tilt: this.tilt,
        depthcams: this.depthcams,
        stereo: this.stereo,
        fisheyes: this.fisheyes,
        inspect_cams: this.inspect_cams,
        insight_cams: this.insight_cams,
        truck: this.truck,
        payload: this.payload,
        id: this.id,
        display_name: this.display_name
    });
  }

  static getAsIterable(map: ExplorerModel): {display: string, model: string | string[] }[] {
    const props = [];
    for(const property in map){
      let display = property;
      // Select only desired properties
      if (property == "id" || property == "createdAt" || property == "updatedAt" || property == "content_url") {
        continue;
      }
      // Format
      else {
        display = display.toLowerCase().replace(/_/g, " ").replace(/(\w)(\w*)/g, function(_g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase();});
      }

      if(Object.prototype.hasOwnProperty.call(map, property) && (map[property.toString()] !== null && map[property.toString()] !== undefined)) {
        props.push({display: display, model: map[property.toString()]})
      }
    }
    return props;
  }
}